// extracted by mini-css-extract-plugin
export default {"container":"PhoneInput__container__v2n5R","inputWrapper":"PhoneInput__inputWrapper__Mh6jT","withValue":"PhoneInput__withValue__h74pg","input":"PhoneInput__input__XICnj"};